function initFaqAccordion() {
    const faqItems = document.querySelectorAll(".faq__item");
    faqItems.forEach((item) => {
        const title = item.querySelector(".faq__item-title");
        const content = item.querySelector(".faq__item-content");
        if (!title || !content) return;
        const contentEl = content as HTMLElement;
        contentEl.style.height = "0px";
        title.addEventListener("click", () => {
            const isActive = item.classList.contains("active");
            if (isActive) {
                contentEl.style.height = contentEl.scrollHeight + "px";
                requestAnimationFrame(() => {
                    contentEl.style.height = "0px";
                });
                item.classList.remove("active");
            } else {
                faqItems.forEach((otherItem) => {
                    if (otherItem !== item && otherItem.classList.contains("active")) {
                        const otherContent = otherItem.querySelector(".faq__item-content");
                        if (!otherContent) return;
                        const otherContentEl = otherContent as HTMLElement;
                        otherContentEl.style.height = otherContentEl.scrollHeight + "px";
                        requestAnimationFrame(() => {
                            otherContentEl.style.height = "0px";
                        });
                        otherItem.classList.remove("active");
                    }
                });
                contentEl.style.height = contentEl.scrollHeight + "px";
                item.classList.add("active");
            }
        });
        contentEl.addEventListener("transitionend", () => {
            if (item.classList.contains("active")) {
                contentEl.style.height = "auto";
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", () => {
    initFaqAccordion();
});

